import React from 'react';
import "./NotFound.css";
const NotFound = () => {
  return (
    <div className="found">Not found ! ! !</div>
  )
}

export default NotFound;